<ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
(onFileLeave)="fileLeave($event)">
<ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
  <button (click)="openFileSelector()" class="upload {{class}}">{{text}}</button>
</ng-template>
</ngx-file-drop>
